// extracted by mini-css-extract-plugin
module.exports = {"comp":"Nav_comp__K1fGu"};